// extracted by mini-css-extract-plugin
export default {"cellhoc":"cell-table-paragraph_cellhoc__OzbhB"};